import React, {Component} from 'react';

class PageNotFound extends Component {
  render() {
    return (
      <div style={{ marginTop: '10%' }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <h1>Page Not Found.</h1>
          <h3></h3>
        </div>
      </div>
    );
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./components/PageNotFound.js